import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["typeSelect", "valuesSection"]
  static values = { selectTypes: Array }

  toggle() {
    const isSelect = this.selectTypesValue.includes(this.typeSelectTarget.value)
    this.valuesSectionTarget.classList.toggle("hidden", !isSelect)
  }
}
